import { render } from "./App.vue?vue&type=template&id=c5313c3a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c5313c3a&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod_electronic-delivery-responsive_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__